// Components
import ChangeEmailView from "../../components/changeEmail";

const ChangeEmail = () => <ChangeEmailView />;

export default ChangeEmail;
